module.exports = __webpack_public_path__ + "img/ic_hegui.fec8d07c.png";